import NextLink from 'next/link';

import { Icon } from '@playbooks/ui/components/icon';

import type { DocsSection } from 'types/docs';

const DocsLinksSection = ({ icon = 'book-open', section }: { icon?: string; section: DocsSection }) => {
	if (!section?.pages?.length) return null;

	return (
		<section className='border-b py-6 last:border-b-0'>
			<NextLink href={section.href} className='group mb-4 inline-flex items-center gap-2 text-foreground'>
				<h2 className='type-heading'>{section.title}</h2>
				<Icon
					type='far'
					icon='chevron-right'
					className='text-sm text-foreground-body transition-transform group-hover:translate-x-0.5'
					aria-hidden
				/>
			</NextLink>
			<div className='grid gap-3 sm:grid-cols-2'>
				{section.pages.map(page => (
					<NextLink
						key={page.href}
						href={page.href}
						className='group flex-start-top min-h-36 gap-4 rounded-media border bg-surface p-5 transition-colors hover:border-border-strong hover:bg-surface-hover'>
						<span className='flex-middle size-9 shrink-0 rounded-panel border bg-surface text-foreground-body'>
							<Icon type='far' icon={icon} aria-hidden />
						</span>
						<div className='min-w-0 grow'>
							<p className='font-medium text-foreground'>{page.title}</p>
							{page.description && (
								<p className='mt-1.5 line-clamp-3 text-sm leading-6 text-foreground-body'>{page.description}</p>
							)}
						</div>
						<Icon
							type='far'
							icon='chevron-right'
							className='mt-1 shrink-0 text-xs text-foreground-body transition-transform group-hover:translate-x-0.5'
							aria-hidden
						/>
					</NextLink>
				))}
			</div>
		</section>
	);
};

export { DocsLinksSection };
